import React, { useEffect, useState } from "react";
import "./index.scss";

export const useOnHydrate = (fn) => {
  const [value, setValue] = React.useState();
  React.useEffect(() => setValue(fn()), []);
  return value;
};

const Pagination = ({ page, setPage, pages }) => {
  let num = page as number;
  const [pageSelected, setPageSelected] = useState<number>(0);
  useEffect(() => {
    setPageSelected(num);
  }, []);
  const emptyButtonLabel = "...";
  const firstPage = 1;
  const pagesArr = new Array(pages).fill(null).map((_, i: number) => ++i);
  const filterInRangePage = (pageToCheck: number): boolean => {
    const adjacentPageToShow = 2;
    if (pageToCheck === 1 || pageToCheck === pages) return true;
    if (num == pageToCheck) return true;
    if (num < pageToCheck && num + adjacentPageToShow >= pageToCheck)
      return true;
    if (num > pageToCheck && num - adjacentPageToShow <= pageToCheck)
      return true;
    return false;
  };
  const handlePrevClick = () => {
    if (num - 1 < 1) {
      return;
    } else {
      setPage(`${num - 1}`);
    }
    window?.location?.reload();
  };
  const handleNextClick = () => {
    if (num + 1 > pages.length) {
      return;
    } else {
      setPage(`${num + 1}`);
    }
    window?.location?.reload();
  };
  const addEmptyButton = (
    acc: (number | string)[],
    curr: number
  ): (number | string)[] => {
    if (curr === firstPage) {
      return [...acc, curr];
    }
    const lastEl = acc[acc.length - 1];
    if (lastEl === firstPage && curr - 1 > firstPage) {
      acc.push(emptyButtonLabel);
    }
    if (curr === pages && lastEl !== pages - 1) {
      acc.push(emptyButtonLabel);
    }
    return [...acc, curr];
  };
  return (
    <>
      <div className="search-pagination">
        <div
          className="SearchPagination__button search-prev"
          onClick={handlePrevClick}
        >
          <span className="arrow">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 12H21.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.5 7L21.5 12L16.5 17"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
        {pagesArr
          .filter(filterInRangePage)
          .reduce(addEmptyButton, [])
          .map((p: number | string, i: number) => {
            if (pageSelected == p) {
              return (
                <button
                  key={`page-${i}`}
                  id={`page-${i}`}
                  itemID={`page-${p}`}
                  onClick={() => {
                    if (num == p) {
                      return;
                    }
                    setPage(`${p}`);
                    window?.location?.reload();
                  }}
                  className="SearchPagination__button active"
                >
                  {p}
                </button>
              );
            } else {
              return (
                <button
                  key={`page-${i}`}
                  id={`page-${i}`}
                  itemID={`page-${p}`}
                  onClick={() => {
                    if ("..." == p) {
                      return;
                    }
                    setPage(`${p}`);
                    window?.location?.reload();
                  }}
                  className="SearchPagination__button "
                >
                  {p}
                </button>
              );
            }
          })}

        <div
          className="SearchPagination__button search-next"
          onClick={handleNextClick}
        >
          <span className="arrow">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 12H21.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.5 7L21.5 12L16.5 17"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    </>
  );
};
export default Pagination;
